import { render, staticRenderFns } from "./ParamsSelect.vue?vue&type=template&id=cc83bf86&scoped=true"
import script from "./ParamsSelect.vue?vue&type=script&lang=js"
export * from "./ParamsSelect.vue?vue&type=script&lang=js"
import style0 from "./ParamsSelect.vue?vue&type=style&index=0&id=cc83bf86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83bf86",
  null
  
)

export default component.exports